import { render, staticRenderFns } from "./UserRegistrationForm.vue?vue&type=template&id=c4c93c98&"
import script from "./UserRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./UserRegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports